import { NotifyHelper } from "../../../helpers/toast";
import { eCategoryActionTypeDefine } from "../../action-types/san-pham/ICategoryActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const categoryActions = {
    ...generateActions(eCategoryActionTypeDefine, "CATEGORY"),
    ...generateActionForKey(eCategoryActionTypeDefine, "CATEGORY", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCategoryActionTypeDefine, "CATEGORY", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCategoryActionTypeDefine, "CATEGORY", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eCategoryActionTypeDefine, "CATEGORY", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}